import React from 'react';
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';
import Header from './components/layout/Header/Header';
import Sidebar from './components/layout/Sidebar/Sidebar';
import Footer from './components/layout/Footer/Footer';
import Dashboard from './pages/Dashboard/Dashboard';
import Analysis from './pages/Analysis/Analysis';
import Chat from './pages/Chat/Chat';
import Documents from './pages/Documents/Documents';
import CompanyReports from './pages/CompanyReports';
import NewsAnalysis from './pages/NewsAnalysis';
import Auth from './pages/Auth/Auth';
import ProtectedRoute from './components/auth/ProtectedRoute/ProtectedRoute';
import './App.css';

// Create a client
const queryClient = new QueryClient();

// Layout component that conditionally shows header/sidebar
const Layout = ({ children }) => {
  const location = useLocation();
  const isAuthPage = location.pathname === '/login';

  if (isAuthPage) {
    return (
      <div className="App">
        {children}
        <Toaster position="top-right" />
      </div>
    );
  }

  return (
    <div className="App">
      <Header />
      <div className="main-container">
        <Sidebar />
        <main className="content">
          {children}
        </main>
      </div>
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <Router future={{ v7_relativeSplatPath: true }}>
        <Layout>
          <Routes>
            <Route path="/login" element={<Auth />} />
            <Route path="/" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/dashboard" element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            } />
            <Route path="/analysis" element={
              <ProtectedRoute>
                <Analysis />
              </ProtectedRoute>
            } />
            <Route path="/chat" element={
              <ProtectedRoute>
                <Chat />
              </ProtectedRoute>
            } />
            <Route path="/documents" element={
              <ProtectedRoute>
                <Documents />
              </ProtectedRoute>
            } />
            <Route path="/company-reports" element={
              <ProtectedRoute>
                <CompanyReports />
              </ProtectedRoute>
            } />
            <Route path="/news-analysis" element={
              <ProtectedRoute>
                <NewsAnalysis />
              </ProtectedRoute>
            } />
          </Routes>
        </Layout>
      </Router>
    </QueryClientProvider>
  );
}

export default App;